import { Title } from '../../Cockpit.styles'
import { CardChartCustomization, ChartTemplate } from '../../Cockpit.types'
import { DataChart } from '../ChartWrapper'
import ResultGoalCardChartItem from './ResultGoalCardChartItem'
import { CardContainer, ChartSection } from './styles'

type ResultGoalCardChartProps = {
  data: DataChart
  title: string
  cardMinWidth?: string
  customization?: CardChartCustomization
  chartTemplate?: Partial<ChartTemplate>
}

const ResultGoalCardChart = ({
  data,
  title,
  customization = { cardMinWidth: '', contentSize: 'small' },
  chartTemplate = {}
}: ResultGoalCardChartProps) => {
  if (!Array.isArray(data) || data.length === 0) {
    return null
  }

  const chartData = data.slice(1)

  return (
    <ChartSection>
      <Title>{title}</Title>
      <CardContainer $cardMinWidth={customization?.cardMinWidth ?? ''}>
        {chartData.map(
          ([
            title,
            subtitle,
            info,
            imageUrl,
            chartColor,
            result,
            goal,
            prefix
          ]) => {
            return (
              <ResultGoalCardChartItem
                key={title}
                title={title}
                result={Number(result)}
                goal={Number(goal)}
                subtitle={String(subtitle)}
                info={info}
                imageUrl={imageUrl}
                chartColor={chartColor}
                prefix={prefix}
                contentSize={customization?.contentSize ?? 'small'}
                chartTemplate={chartTemplate}
              />
            )
          }
        )}
      </CardContainer>
    </ChartSection>
  )
}

export default ResultGoalCardChart
